// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3131) return "css/homepage-4742c139d7006255b581.css";
	if (chunkId === 3130) return "css/page_insertion-99ab2b449cab4e107cd8.css";
	if (chunkId === 5329) return "css/page_affiliation-5d68377a0e73d0d230f5.css";
	if (chunkId === 3092) return "css/page_partnership-8889db0e84d1f3d5ea37.css";
	if (chunkId === 484) return "css/page_pay-f9695269a75c24c5298a.css";
	if (chunkId === 7663) return "css/general_widget-de5c73438b71f54a4e79.css";
	if (chunkId === 9984) return "css/common_widget-4e3d88ba1994f3c9351b.css";
	// return url for filenames based on template
	return "css/" + chunkId + ".css";
};